/* Golden Era 1990s — quote list, finish picker, gallery thumbs, series filter.
   Machines are never added to the cart; they go on this list and are sent to sales@ through the contact form. */
(function () {
  var KEY = 'gm_quote_v1';
  var FINISHES = ['Titanium gold', 'Black', 'Royal blue', 'Pearl white', 'Pearl red', 'Pearl black', 'Black crackle', 'Custom RAL (add the reference in your message)'];

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    refresh();
  }
  function count(items) { return items.reduce(function (n, i) { return n + (i.qty || 1); }, 0); }

  function add(item) {
    var items = read();
    var found = items.find(function (i) { return i.handle === item.handle && i.finish === item.finish; });
    if (found) { found.qty = (found.qty || 1) + 1; } else { item.qty = item.qty || 1; items.push(item); }
    write(items);
  }

  function fromButton(btn) {
    return {
      handle: btn.dataset.handle,
      code: btn.dataset.code || '',
      title: btn.dataset.title,
      url: btn.dataset.url,
      image: btn.dataset.image || '',
      finish: btn.dataset.finish || 'Titanium gold',
      qty: 1
    };
  }

  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    if (text != null) e.textContent = text;
    return e;
  }

  function renderList() {
    var box = document.querySelector('[data-gm-quote-list]');
    var field = document.querySelector('[data-gm-quote-field]');
    var items = read();
    if (field) {
      field.value = items.map(function (i) {
        return (i.code ? i.code + ' ' : '') + i.title + ' — ' + i.finish + ' — qty ' + i.qty;
      }).join('\n');
    }
    var summary = document.querySelector('[data-gm-quote-summary]');
    if (summary) summary.textContent = count(items) + (count(items) === 1 ? ' machine' : ' machines');
    if (!box) return;
    box.textContent = '';
    if (!items.length) {
      var empty = el('p', { class: 'gm-empty' }, 'Your quote list is empty. Add machines from any machine page, or describe what you need in the message.');
      box.appendChild(empty);
      return;
    }
    items.forEach(function (item, idx) {
      var row = el('div', { class: 'gm-qitem' });
      var img = el('img', { src: item.image || '', alt: '', loading: 'lazy', width: '160', height: '120' });
      row.appendChild(img);
      var info = el('div', { style: 'display:flex;flex-direction:column;gap:6px' });
      info.appendChild(el('span', { class: 'gm-caption' }, item.code));
      var name = el('a', { class: 'gm-qitem__name', href: item.url || '#' }, item.title);
      info.appendChild(name);
      var rm = el('button', { type: 'button', class: 'gm-qitem__remove' }, 'Remove');
      rm.addEventListener('click', function () { var a = read(); a.splice(idx, 1); write(a); });
      info.appendChild(rm);
      row.appendChild(info);
      var controls = el('div', { class: 'gm-qitem__controls' });
      var sel = el('select', { 'aria-label': 'Frame finish for ' + item.title });
      FINISHES.forEach(function (f) { var o = el('option', { value: f }, f); if (f === item.finish) o.selected = true; sel.appendChild(o); });
      sel.addEventListener('change', function () { var a = read(); if (a[idx]) { a[idx].finish = sel.value; write(a); } });
      controls.appendChild(sel);
      var step = el('div', { class: 'gm-stepper' });
      var minus = el('button', { type: 'button', 'aria-label': 'Fewer' }, '−');
      var qty = el('span', null, String(item.qty));
      var plus = el('button', { type: 'button', 'aria-label': 'More' }, '+');
      minus.addEventListener('click', function () { var a = read(); if (a[idx]) { a[idx].qty = Math.max(1, a[idx].qty - 1); write(a); } });
      plus.addEventListener('click', function () { var a = read(); if (a[idx]) { a[idx].qty += 1; write(a); } });
      step.appendChild(minus); step.appendChild(qty); step.appendChild(plus);
      controls.appendChild(step);
      row.appendChild(controls);
      box.appendChild(row);
    });
  }

  function refresh() {
    var items = read();
    var n = count(items);
    document.querySelectorAll('[data-gm-quote-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
    renderList();
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-gm-add]');
    if (addBtn) {
      e.preventDefault();
      add(fromButton(addBtn));
      document.querySelectorAll('[data-gm-add][data-handle="' + addBtn.dataset.handle + '"]').forEach(function (b) {
        b.classList.add('is-added');
        var label = b.querySelector('[data-gm-add-label]') || b;
        label.textContent = 'Added — view quote list';
        b.setAttribute('data-gm-go', b.dataset.quoteUrl || '/pages/request-a-quote');
        b.removeAttribute('data-gm-add');
      });
      return;
    }
    var go = e.target.closest('[data-gm-go]');
    if (go) { e.preventDefault(); window.location.href = go.getAttribute('data-gm-go'); return; }

    var all = e.target.closest('[data-gm-add-all]');
    if (all) {
      e.preventDefault();
      try { JSON.parse(all.getAttribute('data-gm-add-all')).forEach(add); } catch (err) {}
      window.location.href = all.dataset.quoteUrl || '/pages/request-a-quote';
      return;
    }

    var fin = e.target.closest('[data-gm-finish]');
    if (fin) {
      var group = fin.closest('[data-gm-finish-group]');
      group.querySelectorAll('[data-gm-finish]').forEach(function (b) { b.setAttribute('aria-pressed', b === fin ? 'true' : 'false'); });
      var label = group.querySelector('[data-gm-finish-label]');
      if (label) label.textContent = fin.dataset.gmFinish;
      document.querySelectorAll('[data-gm-add][data-handle="' + group.dataset.handle + '"]').forEach(function (b) { b.dataset.finish = fin.dataset.gmFinish; });
      return;
    }

    var thumb = e.target.closest('[data-gm-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-gm-main]');
      if (main) { main.src = thumb.dataset.gmThumb; main.removeAttribute('srcset'); main.alt = thumb.dataset.alt || ''; }
      thumb.parentElement.querySelectorAll('[data-gm-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      return;
    }

    var chip = e.target.closest('[data-gm-filter]');
    if (chip) {
      var val = chip.dataset.gmFilter;
      chip.parentElement.querySelectorAll('[data-gm-filter]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      document.querySelectorAll('[data-gm-tags]').forEach(function (card) {
        card.hidden = !(val === 'all' || (' ' + card.dataset.gmTags + ' ').indexOf(' ' + val + ' ') > -1);
      });
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
